/**
 * Archivo principal que exporta todas las funciones de los servicios de Supabase
 * Sirve como punto de entrada para importar cualquier función de la API
 */

import * as djServices from './djServices';
import * as djProfileServices from './djProfileServices';
// import * as utils from '../airtable/utils'; // Podemos reutilizar utils de airtable si son genéricos

// Exportamos todo lo importado
export {
    djServices,
    djProfileServices,
};

// También exportamos cada función individualmente para mantener compatibilidad
export const {
    getDJRecords,
    createSongRequest,
    saveSongRequest,
    getDJInfo,
    deleteDJRecord,
    updateDJInfo,
    updateSongRequestStatus,
    subscribeToDJRequests,
    getAllDJRecords
} = djServices;

export const {
    getDjBio
} = djProfileServices;
